import { render, staticRenderFns } from "./ArenaGames.vue?vue&type=template&id=05e10172&"
import script from "./ArenaGames.vue?vue&type=script&lang=js&"
export * from "./ArenaGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports